import fetch from 'utils/fetch'
/*

cv api

*/
// digest
export function getMetaCvExpDigestEnzyme () {
  return fetch({
    url: '/project/experiment/getMetaCvExpDigestEnzyme',
    method: 'post'
  })
}
export function getMetaCvExpDigestProtocol () {
  return fetch({
    url: '/project/experiment/getMetaCvExpDigestProtocol',
    method: 'post'
  })
}

// instrument
export function getMetaCvExpInstrument (data) {
  return fetch({
    url: '/project/experiment/getMetaCvExpInstrument',
    method: 'post',
    data
  })
}
export function getMetaCvExpInstrumentAnalyzer () {
  return fetch({
    url: '/project/experiment/getMetaCvExpInstrumentAnalyzer',
    method: 'post'
  })
}
export function getMetaCvExpInstrumentAnalyzerTolerance (data) {
  return fetch({
    url: '/project/experiment/getMetaCvExpInstrumentAnalyzerTolerance',
    method: 'post',
    data
  })
}
export function getMetaCvExpInstrumentManufacturer () {
  return fetch({
    url: '/project/experiment/getMetaCvExpInstrumentManufacturer',
    method: 'post'
  })
}
export function saveExpInstrumentation (data) {
  return fetch({
    url: '/project/experiment/saveExpInstrumentation',
    method: 'post',
    data
  })
}
export function getExpInstrumentation (data) {
  return fetch({
    url: '/project/experiment/getExpInstrumentation',
    method: 'post',
    data
  })
}
export function modifyExpInstrumentation (data) {
  return fetch({
    url: '/project/experiment/modifyExpInstrumentation',
    method: 'post',
    data
  })
}

// separation
export function getMetaCvExpSeparationMethod () {
  return fetch({
    url: '/project/experiment/getMetaCvExpSeparationMethod',
    method: 'post'
  })
}
export function modifyExpSearchParameters (data) {
  return fetch({
    url: '/project/experiment/modifyExpSearchParameters',
    method: 'post',
    data
  })
}
// general
export function getProjectCv (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectCv`,
    method: 'post',
    data
  })
}
export function getMetaCvExpType (data) {
  return fetch({
    url: '/project/experiment/getMetaCvExpType',
    method: 'post',
    data
  })
}
export function getMetaCvOmicsType () {
  return fetch({
    url: '/project/experiment/getMetaCvOmicsType',
    method: 'post'
  })
}
// prepration
export function getMetaCvReagentApplication () {
  return fetch({
    url: '/project/experiment/getMetaCvReagentApplication',
    method: 'post'
  })
}

/*
add del modify paste api
*/

export function getExpCode () {
  return fetch({
    url: '/project/experiment/getExpCode',
    method: 'post'
  })
}
export function getExpList (data) {
  return fetch({
    url: '/project/experiment/getExpList',
    method: 'post',
    data
  })
}
export function getExpListData (data) {
  return fetch({
    url: '/project/experiment/getExpListData',
    method: 'post',
    data
  })
}
export function getExpListCount (data) {
  return fetch({
    url: '/project/experiment/getExpListCount',
    method: 'post',
    data
  })
}
export function getExpInfo (data) {
  return fetch({
    url: '/project/experiment/getExpInfo',
    method: 'post',
    data
  })
}
export function getExpView (data) {
  return fetch({
    url: '/project/experiment/getExpView',
    method: 'post',
    data
  })
}
export function saveExpInfo (data) {
  return fetch({
    url: '/project/experiment/saveExpInfo',
    method: 'post',
    data
  })
}
export function modifyExpInfo (data) {
  return fetch({
    url: '/project/experiment/modifyExpInfo',
    method: 'post',
    data
  })
}
export function deleteExp (data) {
  return fetch({
    url: '/project/experiment/deleteExp',
    method: 'post',
    data
  })
}
export function getExperimentTemplate (data) {
  return fetch({
    url: '/project/experiment/getExperimentTemplate',
    method: 'post',
    data
  })
}
/*
draft api
*/
export function deleteExpDraftInfo (data) {
  return fetch({
    url: '/project/experiment/deleteExpDraftInfo',
    method: 'post',
    data
  })
}
export function getExpDraftInfo (data) {
  return fetch({
    url: '/project/experiment/getExpDraftInfo',
    method: 'post',
    data
  })
}
export function getExpDraftList (data) {
  return fetch({
    url: '/project/experiment/getProjectExpDraftList',
    method: 'post',
    data
  })
}
export function saveExpDraftInfo (data) {
  return fetch({
    url: '/project/experiment/saveExpDraftInfo',
    method: 'post',
    data
  })
}
export function getProjectExpDraftList (data) {
  return fetch({
    url: '/project/experiment/getProjectExpDraftList',
    method: 'post',
    data
  })
}
// db search
export function getCvDatabase (data) {
  return fetch({
    url: '/project/search/getCvDatabase',
    method: 'post',
    data
  })
}

export function getCvSearchParamName (data) {
  return fetch({
    url: '/project/search/getCvSearchParamName',
    method: 'post',
    data
  })
}
// export function getCvSearchParamName (data) {
//   return fetch({
//     url: '/project/search/getSearchParameter',
//     method: 'post',
//     data
//   })
// }
// export function saveExpSearchParameters (data) {
//   return fetch({
//     url: '/project/experiment/saveExpSearchParameters',
//     method: 'post',
//     data
//   })
// }
export function saveExpSearchParameters (data) {
  return fetch({
    url: '/project/search/saveSearchParameters',
    method: 'post',
    data
  })
}
export function getExpSearchParameters (data) {
  return fetch({
    url: '/project/search/getSearchParameter',
    method: 'post',
    data
  })
}
export function getCvSearchParamValue (data) {
  return fetch({
    url: '/project/search/getCvSearchParamValue',
    method: 'post',
    data
  })
}
export function getMetaCvModifications () {
  return fetch({
    url: '/project/search/getMetaCvModifications',
    method: 'post'
  })
}
export function getUserListCvByProjectId (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getUserListCvByProjectId`,
    method: 'post',
    data
  })
}
export function getExpIdbyCodes (data) {
  return fetch({
    url: '/project/experiment/getExpIdByCodes',
    method: 'post',
    data
  })
}
export function getExpCodeByIds (data) {
  return fetch({
    url: '/project/experiment/getExpCodeByIds',
    method: 'post',
    data
  })
}
export function getCvProteomicsSubcellularOrganelle () {
  return fetch({
    url: '/project/experiment/getCvProteomicsSubcellularOrganelle',
    method: 'post'
  })
}
export function getCvProteomicsProtocol () {
  return fetch({
    url: '/project/experiment/getCvProteomicsProtocol',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/experiments.js